import EditorAbstractField from "./EditorAbstractField.mjs";
import {Alert} from "reactstrap";

const EditorUnknownField = class extends EditorAbstractField {
	field() {
		return (
			<Alert
				color={ this.state.changes ? "warning" : "secondary"}
				fade={false}
			>
				Il contenuto specifico di questo campo può essere modificato solo manualmente (agendo sul JSON)
			</Alert>
		)
	}
}

export default EditorUnknownField;
